<template>
  <div class="customer-attachments">
    <!-- <p v-for="file in attachments" :key="file.id">
      <span>{{ file.originalName }}</span>
      <span class="preview" @click="getAttachment(file)"> Podgląd</span>
    </p> -->
    <div class="attachments-box" v-if="customer">
      <custom-select
        class="mt-2"
        default-value="AGREEMENT"
        :options="types"
        :graySelect="true"
        :prePick="'AGREEMENT'"
        @newPick="(e) => (selectedType = e)"
      />

      <custom-button
        @click="generatePdf"
        class="mb-1"
        :title="'Wygeneruj'"
        :size="'small'"
      />
    </div>
  </div>
</template>

<script>
import axios from "../../axiosDod";
import CustomButton from "../CustomButton.vue";
import CustomSelect from "../CustomSelect.vue";
export default {
  components: { CustomSelect, CustomButton },
  name: "CustomerAttachments",
  props: ["customer"],
  data() {
    return {
      types: [
        {
          value: "AGREEMENT",
          shortName: "Umowa",
          name: "Umowa",
        },
      ],
      selectedType: "AGREEMENT",
    };
  },
  methods: {
    async generatePdf() {
      if (this.selectedType === "AGREEMENT") {
        const response = await this.$store.dispatch(
          "generateClientAgreementPdf",
          this.customer.id
        );
        const fileURL = window.URL.createObjectURL(new Blob([response]));
        const fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute(
          "download",
          `umowa_klient_${this.customer.clientFirstName.toLowerCase()}_${this.customer.clientLastName.toLowerCase()}.pdf`
        );
        document.body.appendChild(fileLink);
        fileLink.click();
      }
    },

    async getAttachment(file) {
      const { id, originalName, mimetype } = file;
      const response = await axios.get(`cdn/${id}`, {
        responseType: "arraybuffer",
      });

      const blob = new Blob([response.data], { type: mimetype });
      const fileURL = URL.createObjectURL(blob);

      const fileLink = document.createElement("a");

      fileLink.href = fileURL;
      fileLink.setAttribute("download", originalName);
      document.body.appendChild(fileLink);
      fileLink.click();
    },
  },
  computed: {
    attachments() {
      return this.$store.getters.getDodSelectedCustomerAttachments;
    },
  },
};
</script>

<style scoped>
.attachments-box {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-items: center;
  gap: 1rem;
}
.customer-attachments {
  padding: 1rem;
  width: fit-content;
  font-size: 16px;
  padding: 2rem;
}
.preview {
  cursor: pointer;
  text-decoration: underline;
  margin-left: 1rem;
}
</style>